import { render } from "./ProItem.vue?vue&type=template&id=b01c1388&scoped=true"
import script from "./ProItem.vue?vue&type=script&lang=js"
export * from "./ProItem.vue?vue&type=script&lang=js"

import "./ProItem.vue?vue&type=style&index=0&id=b01c1388&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b01c1388"]])

export default __exports__